<!--进场费用分析-->
<template>
    <div>
        <Form ref="applicationForm" :model="application" :rules="applicationRules" inline :label-width="125"
              class="form-common">
            <FormItem label="开始日期" prop="startDate">
                <DatePicker type="date" v-model="application.startDate" placeholder="开始日期"
                            format="yyyy-MM-dd"
                            @on-change="onStartDateChange"
                            style="width: 200px"></DatePicker>
            </FormItem>
            <FormItem label="结束日期" prop="endDate">
                <DatePicker type="date" v-model="application.endDate" placeholder="结束日期"
                            format="yyyy-MM-dd"
                            @on-change="onEndDateChange"
                            style="width: 200px"></DatePicker>
            </FormItem>
            <FormItem label="费用类型" prop="type">
                <Select v-model="application.type" style="width:200px">
                    <Option value="KA">KA</Option>
                    <Option value="非KA">非KA</Option>
                </Select>
            </FormItem>
            <br/>
            <FormItem class="btn-groups">
                <Button type="primary" @click="handleSubmit">查询</Button>
                <ExportButton api="report/getkaOrZhiListDao" :disabled="exportDisabled" :params="exportParams">导出
                </ExportButton>
            </FormItem>
        </Form>
        <Table v-for="key in typeKey" :key="key" :columns="columns" :row-class-name="rowClassName" :data="typeMap[key]"
               border show-summary></Table>


    </div>
</template>

<script>
    import CTable from '@/components/CTable'
    import BtnEvent from '@/components/BtnEvent'
    import {timeFormat, amountFormat, repalceGetParamsByObj} from '@/plugin/tool'
    import {auditStatusList, auditList} from '@/plugin/enum'
    import CusInputView from "../../components/CusInput/CusInputView";
    import ExportButton from "../../components/ExportButton";

    const headerList = [
        {
            fixed: 'left',
            title: '区域',
            key: 'area',
            align: 'center',
            width: 100
        },
        {
            fixed: 'left',
            title: '业务员',
            key: 'yewuyuan',
            align: 'center',
            width: 100
        }
    ]
    const footerList = [
        {
            title: '小计',
            key: 'xiaojiFeiyong',
            align: 'center',
            width: 100
        }, {
            title: '累计',
            key: 'leijiFeiyong',
            align: 'center',
            width: 100
        }
    ]

    export default {
        name: "EntranceFee",
        mixins: [BtnEvent],
        components: {
            ExportButton,
            CusInputView,
            CTable
        },
        computed: {
            exportParams() {
                return this.application
            },
            exportDisabled() {
                return !this.application.startDate || this.application.startDate.length === 0 || !this.application.endDate || this.application.endDate === 0
            }
        },
        data() {
            return {
                date: [],
                vdate: [],//用于选择审核通过日期
                cusList: [],
                application: {
                    page: 1,
                    pageSize: 10,
                    startDate: null,
                    endDate: null,
                    type:null,
                },
                applicationRules: {
                    startDate: [
                        {required: true, message: '请输入开始时间', trigger: 'change'}
                    ],
                    endDate: [
                        {required: true, message: '请输入结束时间', trigger: 'change'}
                    ],
                },
                spList: auditList,
                total: 0,
                queryData: [], // 表格数据
                columns: [],
                typeMap: {},//所有表格
                typeKey: [],
            }
        },
        created() {
        },
        methods: {
            handleCusSuccess(cus) {
                this.application.cusName = cus.cusName
            },
            queryCus(value) {
                this.$fetch('SysCus/getCodeName', {
                    cusName: value
                }).then(res => {
                    this.cusList = res.data.list
                })
            },
            handleSubmit() { // 查询表单校验
                console.log(this.application)
                this.$refs.applicationForm.validate((valid) => {
                    if (valid) {
                        this.application.page = 1
                        this.queryTableData()
                    } else {
                        console.log(valid)
                    }
                })
            },
            queryTableData() { // 查询表格
                this.$fetch('report/getkaOrZhiList', this.application).then(res => {
                    this.queryData = res.data
                    //动态列
                    let tou = res.data.tou;
                    let centerColumns = {
                        title: '费用名称',
                        align: 'center',
                        children: []
                    }
                    _.forEach(tou, t => {
                        centerColumns.children.push({
                            title: t,
                            key: t,
                            align: 'center',
                            width: 100
                        })
                    })

                    this.columns = [
                        ...headerList,
                        centerColumns,
                        ...footerList
                    ]
                    delete res.data.tou
                    this.typeMap = res.data
                    this.typeKey = Object.keys(res.data)
                })
            },
            change(index) {
                this.application.page = index
                this.queryTableData()
            },
            onEndDateChange(val) {
                this.application.endDate = timeFormat(val, 'date')
            },
            onStartDateChange(val) {
                this.application.startDate = timeFormat(val, 'date')
            },
            handleClickExport() {
                this.application.startDate = timeFormat(this.date[0], 'date')
                this.application.closeDate = timeFormat(this.date[1], 'date')
                this.application.shenBeginDate = timeFormat(this.vdate[0], 'date')
                this.application.shenEndDate = timeFormat(this.vdate[1], 'date')
                this.application.cusCode = null;
                _.forEach(this.cusList, value => {
                    if (value.cusName === this.application.cusName) {
                        this.application.cusCode = value.cusCode
                    }
                })


                //点击了导出按钮
                window.location.href = window.location.origin + `/api/SalesPromo/downSalesProExcel?` + repalceGetParamsByObj(this.application)
            },
            rowClassName(row, index) {
                if (row.area === '小计') {
                    return 'demo-table-info-row';
                } else if (row.area === '总计') {
                    return 'demo-table-error-row';
                } else if (row.area === '合计') {
                    return 'demo-table-heji-row'
                }
                return '';
            },

        }
    }
</script>

<style lang="less">
    .ivu-table-summary tr td {
        background-color: #f8f8f9;
    }

</style>
